<template>
    <search-data-table
        :list-route="listRoute"
        :initial-filters="initialFilters"
        :grid-title="`${t('search::page.title.search')} <span class='font-weight-normal'>from</span> ${queryString}`"
    ></search-data-table>
</template>

<script>
export default {
    props: {
        query: {
            type: String,
            required: false,
            default: null,
        },
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            initialFilters: {
                query: this.query,
                entities: null,
            },
        };
    },
    computed: {
        queryString: {
            cache: false,
            get() {
                return this.$store.state.search.queryString;
            },
            set(value) {
                this.$store.dispatch('search/setQueryString', value);
            },
        },
    },
    created() {
        this.queryString = this.query;
    },
};
</script>

<style></style>
